import { render, staticRenderFns } from "./PayFrequenciesDropdownList.vue?vue&type=template&id=6d87f8e4"
import script from "./PayFrequenciesDropdownList.vue?vue&type=script&lang=js"
export * from "./PayFrequenciesDropdownList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports